import { z } from 'zod';

const emailSchema = z.string().email();

export const isValidEmail = (email: string): boolean => {
  return emailSchema.safeParse(email).success;
};
